import Component from '../Component';
import LinksBlock from './LinksBlock';
import childrenInternal from './childrenData/internal';
import LogoMapka from '../../../images/mapka_logo.png';
/* import childrenExternalKorpus from './childrenData/externalKorpus';
import childrenExternal from './childrenData/external';
 */
class Content extends Component {
	constructor() {
		super();

		this.linksBlockInternal = new LinksBlock();
/* 		this.linksBlockExternalKorpus = new LinksBlock();
		this.linksBlockExternal = new LinksBlock(); */
	}

	componentDidMount() {
		this.linksBlockInternal.setRefs(this.refs);
		this.linksBlockInternal.componentDidMount();
/* 		this.linksBlockExternalKorpus.setRefs(this.refs);
		this.linksBlockExternalKorpus.componentDidMount();
		this.linksBlockExternal.setRefs(this.refs);
		this.linksBlockExternal.componentDidMount(); */
	}

	render() {
		return `
            <div class="sidepanel__content--scroll scroll">
                <ul class="sidepanel__items js-side-panel-items">
                    ${this.linksBlockInternal.setChildren(childrenInternal).render()}
                </ul>
				<p class="sidepanel-card__block" style="color: #f1f1f1; padding: .5em 1em;">
    Slepá mapka ponúka možnosť spoznávať jazykovú rozmanitosť Slovenska hravou formou – prostredníctvom kvízov 
	zostavených z autentických nárečových nahrávok dostupných v  
	<a class="link text-nowrap" href="https://mapka.korpus.sk" target="_blank">aplikácii Mapka <i class="fas fa-external-link-alt"></i></a> 
	.
	</p>
				<a class="link text-nowrap" href="https://mapka.korpus.sk/" target="_blank" style="padding: .5em 1em; display: inline-block;">
				   <img src="${LogoMapka}" alt="Logo Mapka" style="height: 3em">
				</a>
            </div>
        `;
/*                     <li class="sidepanel__gutter" /></li>
                    ${this.linksBlockExternalKorpus.setChildren(childrenExternalKorpus).render()}
                    <li class="sidepanel__gutter" /></li>
                    ${this.linksBlockExternal.setChildren(childrenExternal).render()}		 */
	}
}

export default Content;
